import React from 'react';
import PropTypes from 'prop-types';
import { Context } from '../../Context';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Grid, CircularProgress } from '@material-ui/core/';
import CampaignStyles from '../../Styles/CampaignStyles';
import CampaignCard from '../CampaignCard';
import { Mixpanel } from '../../Config/mixpanel';

class Campaigns extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0);
		Mixpanel.track('Viewed page Campaigns');
		this.context.actions.getAdvertiserCampaigns();
	}

	render() {
		const { classes } = this.props;

		let activeCampaigns = [];
		let pastCampaigns = [];

		if (this.context.state.campaigns) {
			activeCampaigns = this.context.state.campaigns.filter((c) => c.status !== 'Finished' && c.status !== 'Cancelled');
			pastCampaigns = this.context.state.campaigns.filter((c) => c.status === 'Finished' || c.status === 'Cancelled');
		}

		return (
			<div className={classes.main}>
				{this.context.state.loading || !this.context.state.campaigns
					? (<CircularProgress size={24} className={classes.progress} />)
					: <div>
						<Typography variant='h4' className={classes.typography}>Active Campaigns</Typography>
						{activeCampaigns.length === 0
							? (<div className={classes.emptyTable}>
								<Typography variant='body1' className={classes.typography}>Nothing to show here</Typography>
								<Typography variant='body2' className={classes.typography}>Go ahead and create a new campaign.</Typography>
							</div>)
							: (<Grid container spacing={2}>
								{activeCampaigns.map((c) => (
									<Grid item xs={12} sm={12} md={8} lg={6} xl={4} key={c._id}>
										<CampaignCard campaign={c} />
									</Grid>
								))}
							</Grid>
							)}
						<div style={{ marginTop: 50 }} />
						<Typography variant='h4' className={classes.typography}>Completed Campaigns</Typography>
						{pastCampaigns.length === 0
							? (<div className={classes.emptyTable}>
								<Typography variant='body1' className={classes.typography}>Nothing to show here</Typography>
								<Typography variant='body2' className={classes.typography}>This is where you will see your past campaigns.</Typography>
							</div>)
							: (
								<Grid container spacing={2}>
									{pastCampaigns.map((c) => (
										<Grid item xs={12} sm={12} md={8} lg={6} xl={4} key={c._id}>
											<CampaignCard campaign={c} key={c._id} />
										</Grid>
									))}
								</Grid>
							)}
					</div>
				}
			</div>
		);
	}
}

Campaigns.propTypes = {
	classes: PropTypes.object.isRequired
};

Campaigns.contextType = Context;

export default withStyles(CampaignStyles)(Campaigns);
